import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'

const SettingsToolbar = ({ onAddReward = () => {} }) => {
  const { t } = useTranslation(['rewards', 'common'])
  const navigate = useNavigate()
  return (
    <div className="rewards-toolbar rewards-toolbar--no-tabs">
      <div className="rewards-toolbar__wrapper">
        <div>
          <button className="button button-black-outline" onClick={() => navigate(-1)}>
            <Icon
              styles={{ width: '20px' }}
              viewBox="0 -4 20 20"
              icon={'arrowLeft'}
              svgProps={{
                stroke: '#646464',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              fill="none"
            />
            {t('common:actions.back')}
          </button>
          <span className="rewards-toolbar__title">{t('rewards:settingsToolbar.title')}</span>
        </div>
        <button className="button button-black" onClick={onAddReward}>
          <Icon icon="settings" viewBox="0 0 24 24" />
          {t('rewards:settingsToolbar.addRewardButton')}
        </button>
      </div>
    </div>
  )
}

SettingsToolbar.propTypes = {
  onAddReward: PropTypes.func,
}

export default SettingsToolbar
